// extracted by mini-css-extract-plugin
export default {"wrapper":"UnorderedList_wrapper__APkCd","item":"UnorderedList_item__MebOR"};